import { useSubscriptionContext } from "@/hooks/use-subscription-provider";

export type {
  SubscriptionTier,
  SubscriptionStatus,
  Subscription,
} from "@/hooks/use-subscription-provider";

// Reads shared subscription state from SubscriptionProvider (mounted once
// at the app root). Safe to call from as many components as you like —
// it no longer opens its own Supabase realtime channel per call.
export function useSubscription() {
  return useSubscriptionContext();
}

// ── Feature gate helpers ──────────────────────────────────────────────────────
// Usage: const canAccess = useFeatureAccess('surf_alerts');

export type ProFeature =
  | "surf_alerts"
  | "favourite_breaks"
  | "session_logging"
  | "extended_forecast";

const PRO_FEATURES: Record<ProFeature, true> = {
  surf_alerts: true,
  favourite_breaks: true,
  session_logging: true,
  extended_forecast: true,
};

export function useFeatureAccess(feature: ProFeature): boolean {
  const { isPro } = useSubscription();
  if (PRO_FEATURES[feature]) return isPro;
  return true; // free feature
}
